module.exports = __webpack_public_path__ + "img/img_assistant_banner.fd3ade7d.png";